import { combineReducers } from "redux";
// Front
import Layout from "./layout/reducer";

// Authentication
import Login from "./auth/login/reducer";
import Account from "./auth/register/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";

//Company
import Company from "./company/reducer";

//User
import User from "./users/reducer";

// Profile
import Profile from "./profiles/reducer";

// Group
import Group from "./groups/reducer";

// Department
import Department from "./departments/reducer";

// Skill
import Skill from "./skills/reducer";

//Exception
import Exception from "./exceptions/reducer";

// Channel
import Channel from "./channels/reducer";

// Operator
import Operator from "./operator/reducer";

// Summarization
import Summarization from "./summarization/reducer";

// Manager
import Manager from "./manager/reducer";

//PredefinedMessage
import PredefinedMessage from "./predefinedmessages/reducer";

//Script
import Script from "./script/reducer";

//AutomaticMessage
import AutomaticMessage from "./automaticmessages/reducer";

//Survey
import Survey from "./surveys/reducer";

//Availability
import Availability from "./availability/reducer";

// Tab
import Tab from "./tabs/reducer";

// Feature
import Feature from "./features/reducer";

// Edit Profile
import EditProfile from "./editprofile/reducer";

// SignalR
import SignalR from "./signalr/reducer";

// Flash Message
import FlashMsgs from "./flashmessage/reducer";

// Transfer Chat
import TransferChat from "./transferChat/reducer";

// Notepad
import Notepad from "./notepad/reducer";

// Header
import Header from "./header/reducer";

// Client Information
import ClientInformation from "./clientInformation/reducer";

// Aditional Fields
import AditionalFields from "./aditionalFields/reducer";

// Insights
import Insights from "./insights/reducer";

// Spy Chat
import SpyChat from "./spyChat/reducer";

// Favorite messages
import FavoriteMessages from "./favoriteMessages/reducer";

// Favorite scripts
import FavoriteScripts from "./favoriteScripts/reducer";

// Murals
import Murals from "./murals/reducer";

// Dashboard
import Dashboards from "./dashboard/reducer";
// Goals
import Goals from "./goals/reducer";

// Change display name
import ChangeDisplayName from "./changeDisplayName/reducer";

// Variables
import Variables from "./variables/reducer";

// Send Status
import SendStatus from "./sendStatus/reducer";

// Reopen Conversations
import ReopenConversation from "./reopenConversation/reducer";

// Custom Widgets
import CustomWidgets from "./widgets/reducer";

//Attachments Interaction
import AttachmentsInteraction from "./attachmentsInteraction/reducer";

// History Interactions
import Interactions from "./interactions/reducer";

// *********************************************
import ConsumerTickets from "./consumerTickets/reducer";

import Metrics from "./metrics/reducer";

import TicketsOperatorArea from "./ticketsOperatorArea/reducer";

import ManagerTickets from "./managerTickets/reducer";

import { periodsReducer } from "./periods/reducer";

import AdditionalFields from "./additionalFields/reducer";

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Company,
  User,
  Profile,
  Group,
  Department,
  Skill,
  Exception,
  Channel,
  PredefinedMessage,
  Script,
  AutomaticMessage,
  Survey,
  Availability,
  Tab,
  Feature,
  Operator,
  Manager,
  EditProfile,
  SignalR,
  FlashMsgs,
  TransferChat,
  Notepad,
  Header,
  ClientInformation,
  AditionalFields,
  Insights,
  SpyChat,
  SendStatus,
  FavoriteMessages,
  FavoriteScripts,
  Murals,
  Dashboards,
  Goals,
  ChangeDisplayName,
  Variables,
  ReopenConversation,
  CustomWidgets,
  ConsumerTickets,
  Interactions,
  AttachmentsInteraction,
  Metrics,
  AdditionalFields,
  Periods: periodsReducer,
  TicketsOperatorArea,
  ManagerTickets,
  Summarization,
});

export default rootReducer;
